import {deepClone} from '@/ft-vue-core/util/helpers'
export default {
  props: {
    /** Custom event to run dialog close on ReservationsItem */
    onClose: Function,
    /** An existing itemData object that can be used to initialize the selected reservation */
    existingItemData: Object,
    /** Indicator used to specify if the new reservation is intended to be a new Floor Plan Walk-In */
    floorPlanWalkInData: Object,
    /** Are we adding a walk-in reservation? */
    addWalkIn: Boolean,
    /** Instead of addinga new walk-in reservation, add a standard reservation */
    addReservation: Boolean,
    /** Automatically selected table IF we are adding a new walk-in reservation here */
    selectedTable: Object,
  },
  data () {
    return {
      lockTimerOverride: undefined,
    }
  },
  mounted () {this.skipRecordLock = !!this.existingItemData},
  watch: {
    /**
     * If we are loading this reservation from Floor Plan, `existingItemData` will exist.
     * In this case, we want to set the `itemData` of `ReservationsItem` manually, suppress
     * `releaseItemLock` and remove processing for `LockTimer`.
     * @param {Boolean} value Boolean representing the open/closed status of this dialog
     */
    showItem (value) {
      if (value) {
        if (this.addWalkIn) {
          const walkInTabIndex = this.reservationTypes.findIndex(t => t.code === 'WALK_IN')
          if (!!this.selectedTable && walkInTabIndex !== -1) {
            this.selectedReservationTypeIndex = walkInTabIndex
            this.addSelectedTableAssignment(this.selectedTable)
          }
          this.backToCaller = this.doClose
        } else if (this.addReservation) {
          const {date} = this.floorPlanWalkInData || {}
          if (date) this.itemData.date = date
          this.addSelectedTableAssignment(this.selectedTable)
        }
        if (this.existingItemData) {
          this.$set(this, 'skipRecordLock', true)
          this.itemData = deepClone(this.existingItemData)
          this.loadData = () => {}
          this.releaseItemLock = () => {} // Suppress releaseItemLock
          this.lockTimerOverride = { // Set custom lockTimerSettings
            endTime: this.existingItemData.recordLockExpiration,
            skipPrompt: true,
          }
        }
      }
    },
    /**
     * Refresh the lock-timer component by resetting `endTime` when recordLockExpiration changes
     * @param {Number} value New record lock expiration after update
     */
    'existingItemData.recordLockExpiration' (value) {
      if (!this.lockTimerOverride) return
      this.$set(this.lockTimerOverride, 'endTime', undefined)
      setTimeout(() => this.$set(this.lockTimerOverride, 'endTime', value))
    }
  },
  methods: {
    /**
     * doClose override. Run this instead of default itemEdit close process.
     * 
     * IF a custom _onClose_ function is defined, run that. ELSE run default _doExit_ function
     */
    doClose () {
      if (!this.onClose) {
        this.doExit(this.backToCaller)
        return
      }
      this.onClose(this.itemData)
    },
    /**
     * Add selected table to Walk-In automatically
     * @param {Object} tables Array of tables to add to this Walk-In automatically
     */
    addSelectedTableAssignment (table = {}) {
      this.itemData.tableAssignments = [{
        reservationId: null,
        locationTableId: table.id,
        locationTableName: table.name,
        quantity: 1,
        autoAssigned: false,
        joined: false
      }]
      this.resetItemFieldErrorLookup()
    },
  }
}